import { render } from "./Example5.vue?vue&type=template&id=30c2e832&scoped=true"
import script from "./Example5.vue?vue&type=script&lang=ts"
export * from "./Example5.vue?vue&type=script&lang=ts"

import "./Example5.vue?vue&type=style&index=0&id=30c2e832&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-30c2e832"

export default script